{
    "general": {
        "back": "Back",
        "close": "Close",
        "cancel": "Cancel",
        "ok": "Ok",
        "next": "Next",
        "optional": "optional",
        "toast": {
            "error": "Error",
            "unknownError": "unknown error"
        },
        "languages": {
            "en": "English",
            "fr": "Français"
        }
    },
    "forms": {
        "errors": {
            "required": "{{field}} is required.",
            "email": "{{field}} is not a valid email address.",
            "minlength": "{{field}} must be at least {{requiredLength}} characters.",
            "maxlength": "{{field}} cannot exceed {{requiredLength}} characters.",
            "min": "{{field}} must be at least {{min}}.",
            "max": "{{field}} cannot exceed {{max}}.",
            "pattern": "{{field}} format is invalid.",
            "invalid": "{{field}} is invalid.",
            "minSelected": "Please select at least {{required}}."
        }
    },
    "shared": {
        "grid": {
            "loading": "Loading...",
            "pageReport": "Showing {first}–{last} of {totalRecords}",
            "locale": {
                "loadingOoo": "Loading...",
                "loadingError": "ERR",
                "noRowsToShow": "No Rows To Show",
                "empty": "Choose One",
                "blanks": "(Blanks)",
                "true": "True",
                "false": "False",
                "contains": "Contains",
                "notContains": "Does Not Contain",
                "equals": "Equals",
                "notEqual": "Does Not Equal",
                "startsWith": "Begins With",
                "endsWith": "Ends With",
                "lessThan": "Less Than",
                "greaterThan": "Greater Than",
                "lessThanOrEqual": "Less Than Or Equal",
                "greaterThanOrEqual": "Greater Than Or Equal",
                "inRange": "Between",
                "inRangeStart": "From",
                "inRangeEnd": "To",
                "blank": "Blank",
                "notBlank": "Not Blank",
                "before": "Before",
                "after": "After",
                "filterOoo": "Filter...",
                "searchOoo": "Search...",
                "applyFilter": "Apply",
                "resetFilter": "Reset",
                "clearFilter": "Clear",
                "cancelFilter": "Cancel",
                "selectAll": "(Select All)",
                "selectAllSearchResults": "(Select All Search Results)",
                "noMatches": "No matches",
                "andCondition": "AND",
                "orCondition": "OR",
                "sortAscending": "Sort Ascending",
                "sortDescending": "Sort Descending",
                "sortUnSort": "Clear Sort",
                "pinColumn": "Pin Column",
                "pinLeft": "Pin Left",
                "pinRight": "Pin Right",
                "noPin": "No Pin",
                "autosizeThiscolumn": "Autosize This Column",
                "autosizeAllColumns": "Autosize All Columns",
                "resetColumns": "Reset Columns",
                "expandAll": "Expand All",
                "collapseAll": "Collapse All"
            }
        }
    },
    "header": {
        "userMenu": {
            "settings": "Settings",
            "darkMode": "Dark Mode",
            "developerMode": "Developer Mode",
            "logOut": "Log Out"
        }
    },
    "pageTitles": {
        "home": "Dashboard",
        "workPackages": {
            "list": "Work Packages",
            "create": "Create Work Package",
            "dashboard": "Dashboard"
        },
        "clients": {
            "list": "Clients",
            "create": "New Client",
            "dashboard": "Dashboard"
        },
        "deviceApprovals": "Device approvals"
    },
    "sidebar": {
        "pages": {
            "workPackages": "Work Packages",
            "clients": "Clients",
            "deviceApprovals": "Device approvals"
        },
        "statusCard": {
            "title": "System Status",
            "statuses": {
                "online": "Online"
            }
        }
    },
    "login": {
        "left": {
            "tagline": "Fournisseur de confiance",
            "endToEndEncrypted": "End-to-end encrypted",
            "zeroKnowledge": "Zero-knowledge architecture"
        },
        "email": {
            "title": "Welcome back",
            "subtitle": "Please enter your email to continue.",
            "emailLabel": "Professional email address",
            "emailPlaceholder": "name@precision.com",
            "requestCode": "Request login code",
            "errors": {
                "invalidEmail": "Invalid email address"
            }
        },
        "otp": {
            "title": "Verify your email",
            "subtitle": "Please enter the 6 digit access code sent to your email.",
            "verifyAndLogin": "Verify and login",
            "errors": {
                "invalidCode": "Invalid code"
            }
        }
    },
    "features": {
        "workPackages": {
            "general": {
                "workPackageStatus": {
                    "active": "Active",
                    "inProgress": "In Progress",
                    "archived": "Archived"
                },
                "fields": {
                    "id": "Work Package ID",
                    "name": "Work Package Name",
                    "description": "Work Package Description",
                    "status": "Work Package Status",
                    "archivedAt": "Archived at",
                    "createdAt": "Created At",
                    "createdBy": "Created By",
                    "lastUpdatedAt": "Last Updated At",
                    "lastUpdatedBy": "Last Updated By",
                    "assignedClients": "Assigned Clients",
                    "project": "Parent project",
                    "emptyProjectMessage": "A new project will be created with this name"
                },
                "createNewWorkPackage": "Create new work package",
                "updateWorkPackage": "Update work package",
                "workPackageDetails": "Work Package Details"
            },
            "list": {
                "title": "Work Package List",
                "table": {
                    "headers": {
                        "workPackage": "Work Package",
                        "status": "Status",
                        "assignedClients": "Assigned Clients",
                        "createdAt": "Created At"
                    },
                    "actions": {
                        "edit": {
                            "name": "Edit",
                            "tooltip": {
                                "allowed": "Edit",
                                "cannotModifyInProgress": "In Progress work packages cannot be modified",
                                "cannotModifyArchived": "Archived work packages cannot be modified"
                            }
                        },
                        "view": {
                            "name": "View Details",
                            "tooltip": {
                                "allowed": "View Details"
                            }
                        }
                    }
                }
            },
            "closeWorkPackage": {
                "header": {
                    "title": "Close work package?"
                },
                "body": {
                    "warning": "This will close the work package and archive it.",
                    "irreversible": "This action cannot be undone."
                },
                "actions": {
                    "confirm": "Confirm close"
                },
                "toast": {
                    "success": "Work package closed.",
                    "error": "Failed to close work package."
                }
            },
            "createWorkPackage": {
                "header": {
                    "title": "Create new work package",
                    "subtitle": "Configure a new collaborative work package. A secure environment will be provisioned."
                },
                "steps": {
                    "workPackageDetails": {
                        "title": "Work Package Details",
                        "placeholders": {
                            "name": "ex. Town Analysis 2024",
                            "description": "Short description of the work package's scope",
                            "project": "Type to search a project"
                        },
                        "assignClients": "Assign Clients"
                    },
                    "clientAssignment": {
                        "title": "Client Assignment",
                        "createWorkPackage": "Create Work Package"
                    },
                    "finished": {
                        "title": "Work Package Created",
                        "body": "\"{{workPackageName}}\" is ready. The assigned clients will be able to access it shortly."
                    }
                }
            },
            "dashboard": {
                "provisioned": "Provisioned",
                "project": "Project",
                "actions": {
                    "close": "Close work package"
                },
                "metrics": {
                    "totalFiles": "Total Files",
                    "pendingFiles": "Pending Files",
                    "assignedClients": "Assigned Clients",
                    "availability": "Availability",
                    "totalFilesSubmitted": "Total Files Submitted",
                    "filesPending": "Files Pending"
                },
                "pipeline": {
                    "title": "Pipeline Status",
                    "completedCount": "{{completed}}/{{total}} completed",
                    "stages": {
                        "schema": "Schema",
                        "mapping": "Mapping",
                        "encryption": "Encryption",
                        "pseudonymization": "Pseudo.",
                        "output": "Output"
                    }
                },
                "assignedClients": {
                    "title": "Assigned Clients"
                },
                "operations": {
                    "title": "Operations",
                    "refresh": "Refresh",
                    "table": {
                        "operationLabel": "Operation",
                        "headers": {
                            "name": "File / Operation",
                            "client": "Client",
                            "fileSize": "Size",
                            "rowCount": "Rows",
                            "columnsSelectedCount": "Columns",
                            "duration": "Duration",
                            "status": "Status"
                        },
                        "fileStatus": {
                            "queued": "Queued",
                            "running": "Processing",
                            "succeeded": "Succeeded",
                            "failed": "Failed"
                        },
                        "operationStatus": {
                            "queued": "Queued",
                            "running": "Processing",
                            "succeeded": "Succeeded",
                            "partialSuccess": "Partial success",
                            "failed": "Failed"
                        }
                    }
                }
            },
            "toast": {
                "updateSuccess": "Work package successfully updated!"
            }
        },
        "clients": {
            "general": {
                "clientStatus": {
                    "active": "Active",
                    "inactive": "Inactive",
                    "pending": "Pending"
                },
                "fields": {
                    "id": "Client ID",
                    "name": "Client Name",
                    "contactPerson": "Contact Person",
                    "contractNumber": "Contract Number",
                    "status": "Client Status",
                    "createdAt": "Created At",
                    "createdBy": "Created By",
                    "lastUpdatedAt": "Last Updated At",
                    "lastUpdatedBy": "Last Updated By",
                    "assignedWorkPackages": "Assigned Work Packages",
                    "entraEnabled": "Entra ID sign-in",
                    "entraTenantId": "Directory (tenant) ID",
                    "entraAppRegistrationId": "Application (client) ID"
                },
                "createNewClient": "Add new client",
                "updateClient": "Update client",
                "clientDetails": "Client Details",
                "entraStatus": {
                    "enabled": "Enabled",
                    "disabled": "Disabled"
                },
                "errors": {
                    "invalidGuid": "{{field}} must be a GUID (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)."
                }
            },
            "list": {
                "title": "Client List",
                "countSuffix": "{{count}} registered",
                "searchPlaceholder": "Search clients...",
                "clearFilters": "Clear filters",
                "table": {
                    "headers": {
                        "clientName": "Client",
                        "contactPerson": "Contact Person",
                        "contractNumber": "Contract Number",
                        "status": "Status",
                        "createdAt": "Created At",
                        "createdBy": "Created By",
                        "numberOfWorkPackagesAssigned": "Work Packages Assigned"
                    },
                    "actions": {
                        "edit": {
                            "name": "Edit",
                            "tooltip": {
                                "allowed": "Edit Client"
                            }
                        },
                        "view": {
                            "name": "View Details",
                            "tooltip": {
                                "allowed": "View Details"
                            }
                        },
                        "regenerateApiKey": {
                            "name": "Regenerate API Key",
                            "tooltip": {
                                "allowed": "Regenerate API Key"
                            }
                        },
                        "revokeAccess": {
                            "name": "Revoke Access",
                            "tooltip": {
                                "allowed": "Revoke Access",
                                "cannotRevokeInactive": "Client has no API keys"
                            }
                        }
                    }
                }
            },
            "createClient": {
                "header": {
                    "title": "Onboard new client",
                    "subtitle": "Register a new entity. This will generate a unique environment and a production API key."
                },
                "steps": {
                    "orgDetails": {
                        "title": "Organization Details",
                        "placeholders": {
                            "name": "ex. Global Logistics Corp",
                            "contactPerson": "ex. John Doe",
                            "contractNumber": "ex. GLC-2026-24551"
                        },
                        "finalizeOnboarding": "Finalize onboarding"
                    },
                    "apiKey": {
                        "title": "Onboarding Successful",
                        "productionApiKey": "Production API Key",
                        "apiKeyPlaceholder": "API Key",
                        "copyApiKey": "Copy API Key",
                        "copyToastMessage": "API Key copied to clipboard",
                        "warning": "Keep this key safe. It will not be displayed again, you will have to regenerate if it gets lost."
                    }
                }
            },
            "regenerateApiKey": {
                "header": {
                    "title": "Regenerate API Key"
                },
                "confirm": {
                    "confirmation": "Are you sure you want to regenerate the API key for this client?",
                    "warning": "This action cannot be undone, and the client's existing API key will be disabled.",
                    "regenerate": "Regenerate"
                },
                "result": {
                    "productionApiKey": "Production API Key",
                    "apiKeyPlaceholder": "API Key",
                    "copyApiKey": "Copy API Key",
                    "copyToastMessage": "API Key copied to clipboard",
                    "warning": "Keep this key safe. It will not be displayed again, you will have to regenerate if it gets lost."
                }
            },
            "revokeApiKey": {
                "header": {
                    "title": "Revoke API Key"
                },
                "body": {
                    "confirmation": "Are you sure you want to revoke the API key for this client?",
                    "consequence": "Doing so will prevent the client from using the client application until a new one is regenerated.",
                    "warning": "This action cannot be undone."
                },
                "actions": {
                    "revoke": "Revoke client access"
                },
                "toast": {
                    "success": "API Key has been successfully revoked!",
                    "error": "Failed to revoke API Key!"
                }
            },
            "dashboard": {
                "assignedWorkPackages": {
                    "title": "Assigned Work Packages"
                },
                "noAssignedWorkPackages": {
                    "title": "No assigned work packages",
                    "description": "Work packages assigned to this client will appear here."
                }
            },
            "detail": {
                "sharingKeys": {
                    "title": "Sharing Keys",
                    "empty": "This client hasn't registered sharing keys yet.",
                    "loadError": "Couldn't load sharing keys.",
                    "fingerprint": "Fingerprint",
                    "registeredAt": "Registered on {{date}}",
                    "disabled": "Disabled",
                    "encryptionKey": {
                        "label": "Encryption key"
                    },
                    "revoke": {
                        "button": "Revoke keys",
                        "confirmHeader": "Revoke sharing keys?",
                        "confirmBody": "This will remove the client's ability to receive shared files. The client will need to register a new pair of keys on a device to receive shares again. Continue?",
                        "pendingSharesWarning": "{{count}} pending share(s) will become undeliverable.",
                        "pendingSharesNone": "No pending shares will be affected.",
                        "toastSuccess": "Sharing keys revoked",
                        "toastError": "Failed to revoke sharing keys."
                    }
                },
                "deviceKeys": {
                    "title": "Device keys",
                    "empty": "This client hasn't enrolled any devices yet.",
                    "loadError": "Couldn't load device keys.",
                    "fingerprint": "Fingerprint",
                    "enrolledAt": "Enrolled on {{date}}",
                    "updatedAt": "Updated on {{date}}"
                }
            },
            "toast": {
                "updateSuccess": "Client successfully updated!"
            }
        },
        "sshKeys": {
            "general": {
                "status": {
                    "pending": "Pending",
                    "active": "Active",
                    "revoked": "Revoked",
                    "rejected": "Rejected"
                }
            },
            "list": {
                "title": "Device approvals",
                "countSuffix": "{{count}} pending",
                "empty": {
                    "title": "No pending device approvals",
                    "description": "Device enrolment requests will appear here for review."
                },
                "table": {
                    "headers": {
                        "clientName": "Client",
                        "fingerprint": "Fingerprint",
                        "createdAt": "Requested",
                        "status": "Status"
                    }
                }
            },
            "actions": {
                "approve": {
                    "tooltip": {
                        "allowed": "Approve device",
                        "notPending": "Only pending requests can be approved"
                    },
                    "confirm": {
                        "title": "Approve device?",
                        "body": "Approve the device with fingerprint {{fingerprint}} for {{client}}. The client will be able to receive shared files on this device."
                    },
                    "toast": {
                        "success": "Device approved.",
                        "error": "Failed to approve device."
                    }
                },
                "reject": {
                    "tooltip": {
                        "allowed": "Reject request",
                        "notPending": "Only pending requests can be rejected"
                    },
                    "confirm": {
                        "title": "Reject request?",
                        "body": "Reject the device enrolment request with fingerprint {{fingerprint}} for {{client}}. The client will need to submit a new request."
                    },
                    "toast": {
                        "success": "Request rejected.",
                        "error": "Failed to reject request."
                    }
                },
                "revoke": {
                    "tooltip": {
                        "allowed": "Revoke access",
                        "notPending": "Only active devices can be revoked"
                    },
                    "confirm": {
                        "title": "Revoke access?",
                        "body": "Revoke access for the device with fingerprint {{fingerprint}} belonging to {{client}}. The device will no longer be able to receive shared files."
                    },
                    "toast": {
                        "success": "Access revoked.",
                        "error": "Failed to revoke access."
                    }
                }
            }
        }
    }
}
